import { http } from "@/http";

export default {
  namespaced: true,

  state: {

  },

  getters: {

  },

  mutations: {
    setState(state, { items, propertyName }) {
      state[propertyName] = items;
    },

  },
  actions: {
    async crudGet({ commit }, { apiRelativePath, propertyName }) {
      const response = await http.get(apiRelativePath)
        .then(response => {
          if(response.status === 200) {
            commit('setState', { items: response.data, propertyName });
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          const err = {
            status: error.status,
            //message: error.data[0].errorCode,
            message: ""
          };

          if (error.status === 404) {
            err.message = "error.load";
          }
          return Promise.reject(err);
        });
      return response;
    },

    async crudGetById({ commit }, { apiRelativePath, id, propertyName }) {
      const response =  await http.get(`${apiRelativePath}/${id}`)
        .then(response => {
          if(response.status === 200) {
            commit('setState', { items: response.data, propertyName });
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          const err = {
            status: error.status,
            message: ""
          };

          if (error.status === 404) {
            err.message = "error.load";
          }
          return Promise.reject(err);
        });
      return response;
    },

    async crudAdd({ commit },crudData) {
      let apiRelativePath = crudData.path
      let saveData = crudData.saveData

      const response = await http.post(apiRelativePath, saveData)
        .then(response => {
          if(([200, 201].includes(response.status))) {
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          const err = {
            status: error.status,
            message: ""
          };
          if(([400, 401, 409, 422].includes(error.status))) {
            const data = Array.isArray(error.data) ? error.data[0] : error.data;
            err.message = data?.errorCode;
          }
          return Promise.reject(err);
        });
      return response;
    },

    async crudUpdate({ commit },  { crudData }) {
      let apiRelativePath = crudData.path
      let saveData = crudData.saveData

      const response = await http.put(apiRelativePath, saveData)
        .then(response => {
          if (response.status === 204) {
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          const err = {
            status: error.status,
            message: ""
          };

          if(([400, 409, 422].includes(error.status))) {
            err.message = error.data[0].errorCode; 
          }
          return Promise.reject(err);
        });
      return response;
    },

    async crudDelete({ commit },  { crudData }) {
      let apiRelativePath = crudData.path
     
      const response = await http.delete(apiRelativePath)
        .then(response => {
          if(response.status === 204) {
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          const err = {
            status: error.status,
            message: ""
          };

          if(([400, 409, 422].includes(error.status))) {
            err.message = error.data[0].errorCode; 
          }
          return Promise.reject(err);
        });
      return response;
    },

    async task({ commit },taskData) {
      let apiRelativePath = taskData.path
      let saveData = taskData.saveData

      const response = await http.post(apiRelativePath, saveData)
        .then(response => {
          if(([200, 204].includes(response.status))) {
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          const err = {
            status: error.status,
            message: ""
          };

          if(([400, 409, 422].includes(error.status))) {
            err.message = error.data[0].errorCode;
          }
          return Promise.reject(err);
        });
      return response;
    },

  },
};
